module.exports = __webpack_public_path__ + "media/images/icons/filled/caret-down-01c7ce540600d47d172847463f95e205.svg";